import type { ChatPageContext } from '@/api/mutations'
import { useRouterState } from '@tanstack/react-router'

/**
 * Derive a chat scope from the current TanStack Router pathname so the
 * backend can scope its tool use to the page the user is looking at
 * (CHAT-007). Falls back to portfolio for unknown routes.
 */
export function useChatPageContext(): ChatPageContext {
  const pathname = useRouterState({ select: (s) => s.location.pathname })
  return contextFromPathname(pathname)
}

export function contextFromPathname(pathname: string): ChatPageContext {
  // /sites/{id}/cameras/{cam}
  let m = pathname.match(/^\/sites\/([^/]+)\/cameras\/([^/]+)\/?$/)
  if (m?.[1] && m[2]) {
    return {
      scope: 'camera',
      site_id: decodeURIComponent(m[1]),
      camera_id: decodeURIComponent(m[2]),
    }
  }
  // /sites/{id}/alerts
  m = pathname.match(/^\/sites\/([^/]+)\/alerts\/?$/)
  if (m?.[1]) {
    return { scope: 'alerts', site_id: decodeURIComponent(m[1]) }
  }
  // /sites/{id} (any sub-route except the two above)
  m = pathname.match(/^\/sites\/([^/]+)(?:\/.*)?$/)
  if (m?.[1]) {
    return { scope: 'site', site_id: decodeURIComponent(m[1]) }
  }
  return { scope: 'portfolio' }
}
